/*
 * Copyright (c) 2022 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { DeviceDto, DevicesListFilterParams, DeviceUSBType } from '../api/devices/devicesClient.typing';
import { DevicesAction, DevicesActionType } from '../actions/devicesActions';
import { DevicesListTableData } from '../../components/RegistryWidgets/Devices/DevicesList/DevicesListConfig';
import { getPageLimitByScreenSize } from '../../utils/utils';

const defaultSearchType: keyof DevicesListTableData = 'factoryNumber';
const defaultUsbType: DeviceUSBType = null;

export interface DevicesState {
    devices: DeviceDto[];
    filterParams: DevicesListFilterParams;
    changedFilterParams: DevicesListFilterParams;
    limit: number;
    afterKeyFactoryNumber: string;
    lastRequestDevicesCount: number;
    isLoading: boolean;
    isCardView: boolean;
}

const initialState: DevicesState = {
    devices: [],
    filterParams: {
        search_type: defaultSearchType,
        search_text: '',
        deviceStatuses: [],
        workabilities: [],
        usbTypes: defaultUsbType,
        firmwareVersions: [],
        operatorNames: [],
    },
    changedFilterParams: null,
    limit: getPageLimitByScreenSize(),
    afterKeyFactoryNumber: null,
    lastRequestDevicesCount: null,
    isLoading: false,
    isCardView: false,
};

function devicesReducer(state: DevicesState = initialState, action: DevicesAction): DevicesState {
    switch (action.type) {
        case DevicesActionType.OPEN_REGISTRY_DEVICES_LIST_PAGE:
            return {
                ...state,
            };

        case DevicesActionType.FETCH_NEXT_PAGE_START:
            return {
                ...state,
                isLoading: true,
                changedFilterParams: null,
            };

        case DevicesActionType.CHANGE_FILTERS:
            return {
                ...state,
                changedFilterParams: action.payload,
            };

        case DevicesActionType.APPLY_FILTERS:
            return {
                ...state,
                isLoading: true,

                devices: [],
                afterKeyFactoryNumber: null,
                lastRequestDevicesCount: null,

                filterParams: state.changedFilterParams ? { ...state.changedFilterParams } : { ...state.filterParams },
                changedFilterParams: null,
            };

        case DevicesActionType.CHANGE_CURRENT_VIEW:
            return {
                ...state,
                isCardView: action.payload,
            };

        case DevicesActionType.FETCH_DEVICES_PAGE_SUCCESS:
            const combinedList: DeviceDto[] = [...state.devices];

            if (action.payload.list.devices && action.payload.list.devices.length > 0) {
                combinedList.push(...action.payload.list.devices);
            }
            return {
                ...state,
                devices: combinedList,
                afterKeyFactoryNumber: action.payload.list.afterKeyFactoryNumber,
                lastRequestDevicesCount: action.payload.list.devices.length,
                isLoading: false,
            };

        case DevicesActionType.FETCH_DEVICES_PAGE_ERROR:
            return {
                ...state,
                isLoading: false,
            };

        case DevicesActionType.DOWNLOAD_EXCEL_START:
            return {
                ...state,
                isLoading: true,
                changedFilterParams: null,
            };

        case DevicesActionType.DOWNLOAD_EXCEL_SUCCESS:
        case DevicesActionType.DOWNLOAD_EXCEL_ERROR:
            return {
                ...state,
                isLoading: false,
            };

        case DevicesActionType.EXIT_REGISTRY_DEVICES_LIST_PAGE:
            return {
                ...state,
                changedFilterParams: null,
            };

        default:
            return state;
    }
}

export default devicesReducer;
